import React from 'react'

export default function Container({fluid=false, children}) {
    return (
        <div className={`container${ fluid=== true ? "-fluid" : ""}`}>
            {children}
        </div>
    )
}
